import { render, staticRenderFns } from "./CustomersTableFilters.vue?vue&type=template&id=6930620a&scoped=true"
import script from "./CustomersTableFilters.vue?vue&type=script&lang=js"
export * from "./CustomersTableFilters.vue?vue&type=script&lang=js"
import style0 from "./CustomersTableFilters.vue?vue&type=style&index=0&id=6930620a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930620a",
  null
  
)

export default component.exports